import { getApiContext, GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import Procurements from "~/views/procurements"

const getInitialProps: GetInitialPropsType = async ({ req, query: { ...query } }) => {
  const apiContext = await getApiContext(
    [
      {
        url: "/procurement/list",
        query: { items_per_page: 5, page_number: 1, status: "active", ...query },
      },
      { url: "/procurementcategories/list" },
      { url: "/rubrics/list" },
    ],
    req ? req.headers.host : location.host,
  )
  const crumbs = generateCrumbs(req?.url)

  return { apiContext, crumbs }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
Procurements.getInitialProps = getInitialProps

export default Procurements
